/** @format */

import { Type } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

export interface AppModuleLoader {
  AppModule: Type<unknown>;
}

export async function bootstrapAngularApp(moduleLoader: Promise<AppModuleLoader>): Promise<void> {
  const { AppModule } = await moduleLoader;
  await platformBrowserDynamic().bootstrapModule(AppModule as Type<any>);
}
